import React from 'react';
import {Breadcrumb, Button} from "antd";

/**
 * Breadcrumb navigation built on AntD Breadcrumb.
 *
 * ⚠️ WIP — only works with `onClick` handler functions, not plain href links.
 *
 * For router-based navigation, use `useBreadcrumbComponent` instead, which
 * builds the breadcrumb automatically from the NavigationContext trail.
 *
 * **Usage rules:**
 * - Only use on pages that have no tabs — combining breadcrumbs and tabs causes user confusion.
 * - Order items from highest-level page down to current context.
 * - Set `showEndingSeparator` when a heading (`<h2>` etc.) follows immediately
 *   after the breadcrumb. Omit it when the final crumb is the page name itself.
 *
 * @example
 * // Manual usage
 * <BreadcrumbAntd
 *   breadcrumbs={[
 *     { label: 'Reports', function: () => navigate('/reports') },
 *     { label: 'Student Reports', function: () => navigate('/reports/students') },
 *   ]}
 * />
 *
 * @example
 * // With ending separator (heading follows)
 * <BreadcrumbAntd breadcrumbs={crumbs} showEndingSeparator />
 * <h2>Timmy McGee</h2>
 *
 * @param {{ label: string, function: () => void }[]} breadcrumbs - Ordered list of crumb items.
 * @param {boolean} [showEndingSeparator] - Appends a trailing `>` separator after the last crumb.
 */
const BreadcrumbAntd = ({ breadcrumbs, showEndingSeparator }) => {

    const breadcrumbItems = [
        ...breadcrumbs.map(breadcrumb => ({
            title: (
                <Button
                    type="link"
                    className="ch-breadcrumb-button"
                    onClick={breadcrumb.function}
                >
                    {breadcrumb.label}
                </Button>
            )
        })),
        ...(showEndingSeparator ? [{ title: <></> }] : [])
    ];

    return (
        <Breadcrumb
            items={breadcrumbItems}
            separator={'>'}
        />
    );
};

export default BreadcrumbAntd;